import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-undo",
  "use": "rt-base-undo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-undo\"><path d=\"M800.9 176.6C741.3 116.9 661.9 84 577.5 84c-83.8 0-164.2 33.3-223.5 92.6-59.7 59.7-92.6 139-92.6 223.4v311.2h-123c-6.8 0-10.5 8-6.1 13.2L273 928.8c12.8 15 36 15 48.8 0l140.7-204.4c4.2-4.9 1.1-12.3-5-13.1H333.4V400c0-65.2 25.4-126.4 71.5-172.5C451 181.4 512.3 156 577.4 156c64.8 0 126.7 25.6 172.5 71.5 46.1 46.1 71.5 107.4 71.5 172.5v424c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16V400c0.1-84.4-32.8-163.8-92.5-223.4z\" p-id=\"3764\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/undo.svg
// module id = 1800
// module chunks = 137